module.exports = __webpack_public_path__ + "static/devteam_05-e7e21e9a1a97e1c6b58e02f64573bdd3.jpg";